import { render, staticRenderFns } from "./PartnerUsers.vue?vue&type=template&id=248ff7f9&scoped=true"
import script from "./PartnerUsers.vue?vue&type=script&lang=ts"
export * from "./PartnerUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ff7f9",
  null
  
)

export default component.exports